const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Group 5 PR B: the Discord link ?open=chat&conversation=<uuid>. Accepts only
// open=chat with a UUID-shaped conversation; the raw params are never rendered.
export function parseChatDeepLink(search) {
  const params = new URLSearchParams(search || '');
  if (params.get('open') !== 'chat') return null;
  const id = params.get('conversation');
  if (!id || !UUID_RE.test(id)) return null;
  return { conversationId: id.toLowerCase() };
}
